import styled from '@emotion/styled';

const ButtonWrapper = styled('div')(() => ({
  height: '4rem',
  marginTop: '2rem',
  flex: 1,
}));

export default ButtonWrapper;
